import script from "./incorporation-form-conf-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./incorporation-form-conf-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__